export default __webpack_public_path__ + "static/backgroundFeatures-2e3a82cbbf53e4fab122f46ef161a4a4.jpg";